import { interactionModelOperations } from '../../interaction/redux'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useAppDispatch } from 'state/store'

export const useSetWorkflow = async () => {
  const [searchParams] = useSearchParams()
  const workflowUuid = searchParams.get('uuid_workflow')
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(interactionModelOperations.setWorkflow(workflowUuid || null))
  }, [dispatch, workflowUuid])
}

export default useSetWorkflow
